import { Component, ReactNode } from 'react';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { Home, Refresh } from 'iconsax-react';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true };
  }

  handleRefresh = (): void => {
    window.location.reload();
  };

  handleNavigateHome = (): void => {
    window.location.href = '/';
  };
  render() {
    if (this.state.hasError) {
      return (
        <Grid container spacing={3} direction="column" alignItems="center" justifyContent="center" sx={{ minHeight: '100vh', py: 2 }}>
          <Grid item xs={12}>
            <Box sx={{ width: { xs: 300, sm: 374 } }}>
              <img src={'/error-boundary.png'} alt="error-boundary-img" style={{ width: '100%', height: 'auto' }} />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Stack spacing={2} justifyContent="center" alignItems="center">
              <Typography align="center" variant="h1">
                Something Went Wrong
              </Typography>
              <Typography color="textSecondary" align="center" sx={{ width: '85%' }}>
                Oops! It looks like something went wrong. Please try again later.
              </Typography>
              <Grid container spacing={2} alignItems={'center'} justifyContent={'center'} gap={2}>
                <Button startIcon={<Refresh />} variant="contained" onClick={this.handleRefresh}>
                  Refresh
                </Button>
                <Button startIcon={<Home />} variant="contained" onClick={this.handleNavigateHome}>
                  Home
                </Button>
              </Grid>
            </Stack>
          </Grid>
        </Grid>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
